import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-address-third-party-consignment-field',
  templateUrl: './address-third-party-consignment-field.component.html',
  styleUrls: ['./address-third-party-consignment-field.component.scss']
})
export class AddressThirdPartyConsignmentFieldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
